import { type CMSData } from '@/features/cms/components/CMS/types'
import { getLocalSchemaMetadata } from '@/features/shared/utils/seo/getLocalSchemaMetadata'
import { getRetailerShelfSchema } from '@/features/shared/utils/seo/getRetailerShelfSchema'
import { getFAQSchema } from '@/features/shared/utils/seo/getFAQSchema'
import { getServiceSchema } from '@/features/shared/utils/seo/getServiceSchema'
import { getPlaceSchema } from '@/features/shared/utils/seo/getPlaceSchema'
import { getProductShelfSchemas } from '@/features/shared/utils/seo/getProductShelfSchemas'
import { getBodyContentWithLayoutGroupChildren } from '@/features/shared/utils/seo/getBodyContentWithLayoutGroupChildren'

type Props = {
  cmsData: CMSData
  canonicalUrl: string
}

export const buildCmsStructuredData = ({ cmsData, canonicalUrl }: Props) => {
  const { city, state, zip } = getLocalSchemaMetadata(cmsData)
  const bodyContent = getBodyContentWithLayoutGroupChildren(cmsData)

  const retailerShelfSchema = getRetailerShelfSchema({
    city,
    canonicalUrl,
    bodyContent,
  })
  const faqSchema = getFAQSchema({
    canonicalUrl,
    bodyContent,
  })
  const serviceSchema = getServiceSchema({ city, state, zip, canonicalUrl })
  const placeSchema = getPlaceSchema({ city, state })
  const productShelfSchemas = getProductShelfSchemas({
    city,
    canonicalUrl,
    bodyContent,
  })

  return [
    ...(serviceSchema ? [serviceSchema] : []),
    ...(placeSchema ? [placeSchema] : []),
    ...(retailerShelfSchema ? [retailerShelfSchema] : []),
    ...(productShelfSchemas ?? []),
    ...(faqSchema ? [faqSchema] : []),
  ]
}
